<template>
    <div id="detail" class="background-ash pl20 pr20 pb20">
        <el-tabs v-model="activeName" type="card" class="background-white">
            <el-tab-pane label="基础信息" name="1">
                <div class="content background-white">
                    <ul>
                        <li><span class="title">有效期：</span>截止于
                            <span v-if="detail.expireStatus === 'USE'">{{ detail.gmtExpire }}</span>
                            <span v-if="detail.expireStatus === 'NEAR_EXPIR'" class="color-red">{{ detail.gmtExpire }}</span>
                            <span v-if="detail.expireStatus === 'EXPIRED'" class="color-909399">{{ detail.gmtExpire }}</span>
                        </li>
                        <li><span class="title">登录限制：</span>每7天可更换{{ detail.sevenReplaceDeviceNum }}个设备</li>
                        <li><span class="title">账号：</span>{{detail.mobile}}</li>
                        <li><span class="title">公司名称：</span>{{detail.companyName}}</li>
                        <li><span class="title">联系电话：</span>{{detail.mobile}}</li>
                        <li><span class="title">地址：</span>{{detail.province+detail.city+detail.district}}</li>
                        <li><span class="title">审核状态：</span>
                            <span v-if="detail.authenticationStatus==='INIT'">待认证</span>
                            <span v-else-if="detail.authenticationStatus==='AUDITING'">认证审核中</span>
                            <span v-else-if="detail.authenticationStatus==='PASS'">认证通过</span>
                            <span v-else-if="detail.authenticationStatus==='FAILED'">认证失败</span>
                            <span v-else>已过期</span>
                        </li>
                        <li>
                            <span class="title">所属分组：</span>{{detail.groupName}}
                        </li>
                        <li><span class="title">注册时间：</span>{{detail.gmtRegister}}</li>
                        <li><span class="title">登录时间：</span>{{detail.gmtLastLogin}}</li>
                        <li><span class="title">状态：</span>
                            {{detail.status === 'ENABLED' ? '启用' : '禁用'}}
                        </li>
                        <li><span class="title">查询平台：</span>
                            <span v-for="item in platform" :key="item">{{item}}、</span>
                        </li>
                        <li><span class="title">&nbsp;</span>
                            <el-button type="primary" size="small" @click="callback">返回</el-button>
                        </li>
                    </ul>
                </div>
            </el-tab-pane>
            <el-tab-pane label="登录信息" name="2">
                <div class="search_list background-white">
                    <ul class="lists">
                        <li>
                            <span>电脑编号</span>
                            <el-input size="small" class="width180" @keyup.native.enter="pageNo = 1, getList()" v-model="deviceNo" placeholder="请输入电脑编号"></el-input>
                        </li>
                        <li>
                            <span>最近登录</span>
                            <el-date-picker size="small" v-model="time" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                        </li>
                    </ul>
                    <div class="btns" style="width: 140px;">
                        <el-button type="primary" plain size="small" @click="callback">返回</el-button>
                        <el-button size="small" type="primary" @click="pageNo = 1, getList()">搜索</el-button>
                    </div>
                </div>
                <div class="pt20 content">
                    <!--表头操作-->
                    <div class="watchBar">
                        <span class="color-red">*每7天可更换{{ detail.sevenReplaceDeviceNum }}个设备</span>
                    </div>
                    <!--表格-->
                    <div class="tab">
                        <el-table ref="checkList" row-key="id" size="mini" :data="list" tooltip-effect="dark">
                            <el-table-column type="index" width="50" fixed></el-table-column>
                            <el-table-column label="电脑编号" prop="deviceNo"></el-table-column>
                            <el-table-column label="最近登录时间" prop="gmtLastLogin"></el-table-column>
                            <el-table-column label="操作" width="250">
                                <template slot-scope="scope">
                                    <el-button type="text" @click="deleteItem(scope.row)">删除设备</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="page background-white text-right p20">
                        <el-pagination @size-change="changeSize" @current-change="changePageNo" :current-page.sync="pageNo"
                        :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
                        </el-pagination>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
export default {
	name: 'detail',
	data () {
		return {
            id: 0,
			detail: {},
            platform: [],
            activeName: '1',
            deviceNo: '',
            time: [],
            pageNo: 1,
            pageSize: 10,
            list: [],
            totalCount: 0,
            groupList: [], //分组
		}
	},
	watch: {
	},
	methods: {
        changeSize(val) {
            this.pageSize = val
            this.pageNo = 1
            this.getList()
        },
        changePageNo(val) {
            this.pageNo = val - 1
            this.getList()
        },
		getDetail () {
            this.$http('POST', '/admin/user/view', {}, {id: this.id} , (statu, res) => {
                if (statu) {
                    this.detail = res.data;
                    this.detail.groupName = ''
                    if (Array.isArray(res.data.groupIdList) && res.data.groupIdList.length > 0) {
                        res.data.groupIdList.forEach((id,index1)=>{
                            this.groupList.forEach((el,index2)=>{
                                if (id === el.id) {
                                    this.detail.groupName += el.name + ((index1+1) < res.data.groupIdList.length ? '，' : '')
                                }
                            })
                        })
                    }
                    if ( !!res.data.platforms && res.data.platforms.length > 0 ) {
                        this.platform = res.data.platforms.map( (item) => {return item.platformName})
                    }
                }
            })
        },
        //返回列表
        callback () {
            this.$router.back(-1);
        },
        // 获取社保列表
        getList() {
            let options = {
                userId: this.id,
                deviceNo: this.deviceNo,
                geGmtLastLogin: Array.isArray(this.time) && this.time.length === 2 ? this.time[0] : '',
                leGmtLastLogin: Array.isArray(this.time) && this.time.length === 2 ? this.time[1] : '',
                page: this.pageNo - 1,
                size: this.pageSize
            }
            for(let key in options) {
                if (options[key] === '') {
                    delete options[key]
                }
            }
            this.$http('POST', '/admin/user/page/login', {}, options , (statu, res) => {
                if (statu) {
                    this.list = res.content
                    this.totalCount = res.totalCount
                }
            })
        },
        // 删除设备
        deleteItem(item) {
            this.$confirm('是否删除选中的设备信息？', '删除设备', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    console.log('删除')
                    this.$http('POST', '/admin/user/delete/login/device', {}, {id: item.id} , (statu, res) => {
                        if (statu) {
                            this.success('操作成功')
                            this.getList()
                        }
                    })
            }).catch()
        },
        //获取所有分组
        getGroupList () {
            this.$http('post', '/admin/userGroup/findAllGroup', {}, {}, (status, res) => {
                if (status) {
                    if(!!res.data && res.data.length > 0) {
                        this.groupList = res.data;
                    }else {
                        this.groupList = [];
                    }
                    this.getDetail();
                }
            });
        },
	},
	mounted () {
        this.id = this.$route.query.id;
        this.getGroupList()
        this.getList()
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#detail{width: 100%;height: 40px;}
#detail {width: 100%;height: calc(100vh - 132px); }
#detail .content {height: 100%; width: 100%; padding: 10px;overflow-y: auto;}
#detail .content ul>li{margin-bottom: 20px; color: #333;}
#detail .content ul>li>.title{display: inline-block; width: 100px; text-align: right; color: #666; margin-right: 25px;}

</style>



// WEBPACK FOOTER //
// src/views/user/detail.vue